import { allowedSignalKinds } from '../../constants/allowedSignalKinds';
import { checkMatch } from '../general/checkMatch';
/**
 * Get all different 1D signals from experiments with allowed signal kinds in "signalKindsToInclude".
 *
 * @param {ExperimentsType} experiments1D
 */
export function getSignals1D(experiments1D) {
    // store valid signals from 1D experiments
    const signals1DByAtomType = {};
    for (const atomType in experiments1D) {
        const signals = [];
        const experiment = experiments1D[`${atomType}`] || [];
        if (experiment.length === 0)
            continue;
        const index = 0;
        const spectrum1D = experiment[index];
        for (const range of spectrum1D.ranges.values) {
            for (const signal of range.signals) {
                if (!signal.kind || !allowedSignalKinds.includes(signal.kind))
                    continue;
                if (!checkExistence(signal, signals)) {
                    signals.push({
                        experimentType: '1d',
                        experimentID: spectrum1D.id,
                        integration: signal.integration
                            ? signal.integration
                            : range.integration,
                        atomType,
                        signal: { ...signal },
                    });
                }
            }
        }
        signals1DByAtomType[atomType] = signals;
    }
    return signals1DByAtomType;
}
function checkExistence(current, group) {
    for (const element of group) {
        if (checkMatch(element.signal.delta, current.delta, 0.0)) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U2lnbmFsczFELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxpdGllcy9zaWduYWxzL2dldFNpZ25hbHMxRC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxvQ0FBb0MsQ0FBQztBQUt4RSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sdUJBQXVCLENBQUM7QUFFbkQ7Ozs7R0FJRztBQUNILE1BQU0sVUFBVSxZQUFZLENBQzFCLGFBQThCO0lBRTlCLDBDQUEwQztJQUMxQyxNQUFNLG1CQUFtQixHQUF3QixFQUFFLENBQUM7SUFDcEQsS0FBSyxNQUFNLFFBQVEsSUFBSSxhQUFhLEVBQUU7UUFDcEMsTUFBTSxPQUFPLEdBQThCLEVBQUUsQ0FBQztRQUM5QyxNQUFNLFVBQVUsR0FBRyxhQUFhLENBQUMsR0FBRyxRQUFRLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUV0RCxJQUFJLFVBQVUsQ0FBQyxNQUFNLEtBQUssQ0FBQztZQUFFLFNBQVM7UUFFdEMsTUFBTSxLQUFLLEdBQUcsQ0FBQyxDQUFDO1FBQ2hCLE1BQU0sVUFBVSxHQUFHLFVBQVUsQ0FBQyxLQUFLLENBQWUsQ0FBQztRQUVuRCxLQUFLLE1BQU0sS0FBSyxJQUFJLFVBQVUsQ0FBQyxNQUFNLENBQUMsTUFBTSxFQUFFO1lBQzVDLEtBQUssTUFBTSxNQUFNLElBQUksS0FBSyxDQUFDLE9BQU8sRUFBRTtnQkFDbEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQztvQkFBRSxTQUFTO2dCQUN4RSxJQUFJLENBQUMsY0FBYyxDQUFDLE1BQU0sRUFBRSxPQUFPLENBQUMsRUFBRTtvQkFDcEMsT0FBTyxDQUFDLElBQUksQ0FBQzt3QkFDWCxjQUFjLEVBQUUsSUFBSTt3QkFDcEIsWUFBWSxFQUFFLFVBQVUsQ0FBQyxFQUFFO3dCQUMzQixXQUFXLEVBQUUsTUFBTSxDQUFDLFdBQVc7NEJBQzdCLENBQUMsQ0FBQyxNQUFNLENBQUMsV0FBVzs0QkFDcEIsQ0FBQyxDQUFDLEtBQUssQ0FBQyxXQUFXO3dCQUNyQixRQUFRO3dCQUNSLE1BQU0sRUFBRSxFQUFFLEdBQUcsTUFBTSxFQUFFO3FCQUN0QixDQUFDLENBQUM7aUJBQ0o7YUFDRjtTQUNGO1FBRUQsbUJBQW1CLENBQUMsUUFBUSxDQUFDLEdBQUcsT0FBTyxDQUFDO0tBQ3pDO0lBQ0QsT0FBTyxtQkFBbUIsQ0FBQztBQUM3QixDQUFDO0FBRUQsU0FBUyxjQUFjLENBQUMsT0FBWSxFQUFFLEtBQWdDO0lBQ3BFLEtBQUssTUFBTSxPQUFPLElBQUksS0FBSyxFQUFFO1FBQzNCLElBQUksVUFBVSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLEVBQUU7WUFDeEQsT0FBTyxJQUFJLENBQUM7U0FDYjtLQUNGO0lBQ0QsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDIn0=